<div class="row justify-content-center align-items-center" mat-dialog-title>
    <div class="col-md-10 col-10">
        <h5 class="text-left txt-primario">Terceros</h5>
    </div>
    <div class="col-md-2 col-2 text-right">
        <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
    </div>
</div>
<mat-dialog-content class="py-0">
    <app-crear-actualizar-terceros [datosTerceros]="tercerosComplemento" [modulo]="this.data.modulo"
        (eventosTerceros)="procesarEventosTerceros($event)">
    </app-crear-actualizar-terceros>
</mat-dialog-content>